import { v4 as uuidv4 } from "uuid";
export class ProjectGridViewModel {
    constructor() {
        this.id = uuidv4();
        this.code = "";
        this.name = "";
        this.description = "";
        this.createdBy = "";
        this.ownedBy = "";
        this.isResponse = false;
    }
}
export default class ProjectGridView extends ProjectGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
